<template>
    <el-dialog
        :custom-class="prefix"
        append-to-body
        title="添加补充合同"
        :visible="dialogVisible"
        width="500px"
        :before-close="handleClose">
        <el-form :class="`${prefix}-contract-list`">
            <el-form-item :label="contract.name" v-for="(contract, idx) in contracts" :key="idx">
                <i class="el-icon-delete" @click="delPhotoworkContract(contract.name)"></i>
            </el-form-item>
        </el-form>
        <el-input v-model="contract" placeholder="请输入合同归档号ID，添加绑定">
            <template v-slot:suffix>
                <el-button :loading="loading" :class="`${prefix}-btn`" type="primary" @click="bindClick">绑定</el-button>
            </template>
        </el-input>
    </el-dialog>
</template>
<script>
const prefix = "w-supplementary-contract-dialog"

export default {
    props: {
        value: Boolean,
        id: [ String, Number ],
        params: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            dialogVisible: false,
            prefix,
            // 已绑定的合同列表
            contracts: [],
            // 当前编辑的合同ID
            contract: '',
            loading: false
        };
    },
    methods: {
        init() {},
        handleClose() {
            this.dialogVisible = false
            this.$emit('input', false)
            this.$emit('close')
        },
        bindClick() {
            this.photoworkAddContract()
        },
        async photoworkAddContract() {
            let apiName = 'photoworkAddContract'

            if(this.params.type === 9) {
                apiName = 'contributionworkAddContract'
            }
            this.loading = true
            try {
                await this.api[apiName](Object.assign({ photoId: this.id, archiveId: this.contract }, this.params))
                this.$message.success('合同绑定成功')
                this.contract = ''
                this.getPhotoworkContractList()
            } finally {
                this.loading = false
            }
        },
        async getPhotoworkContractList() {
            let apiName = 'getPhotoworkContractList'

            if(this.params.type === 9) {
                apiName = 'getContributionworkContractList'
            }

            let data = await this.api[apiName](Object.assign({ photoId: this.id }, this.params))

            this.contracts = data
        },
        async delPhotoworkContract(contract) {
            let apiName = 'delPhotoworkContract'

            if(this.params.type === 9) {
                apiName = 'contributionworkDelContract'
            }

            await this.api[apiName](Object.assign({ photoId: this.id, archiveId: contract }, this.params))

            this.$message.success('合同绑定已解除')
            this.getPhotoworkContractList()
        }
    },
    created() {
        this.init();
    },
    computed: {
        classes() {
            return [prefix];
        },
    },
    watch: {
        value(val) {
            this.dialogVisible = val

            if(val) {
                this.getPhotoworkContractList()
            }
        }
    }
};
</script>

<style lang="scss">
$prefixCls: w-supplementary-contract-dialog;

.#{$prefixCls} {
    .el-dialog__body{
        padding: 40px !important;
    }
    & &-btn{
        margin-right: -6px;
    }
    .el-icon-delete {
        cursor: pointer;
    }
}
</style>
